/*
 * OverlayScreens
 * ==========
 */

import GameStartScreen from '../ui/GameStartScreen'
import LevelStartScreen from '../ui/LevelStartScreen'
import GameSummaryScreen from '../ui/GameSummaryScreen'
import PauseScreen from '../ui/PauseScreen'
import FakePauseScreen from '../ui/FakePauseScreen'
import DoubleScoreScreen from '../ui/DoubleScoreScreen'
import ExitGameScreen from '../ui/ExitGameScreen'
import HelpScreen1 from '../ui/HelpScreen1'
import HelpScreen2 from '../ui/HelpScreen2'
import HelpScreen3 from '../ui/HelpScreen3'
import HelpScreen4 from '../ui/HelpScreen4'
import HelpScreen5 from '../ui/HelpScreen5'

export default class OverlayScreens {

    constructor(game) {
        this.view = game.make.group();
        this.game = game;

        if (!GS.game.device.webGL || GS.game.renderType === 1) {
            this.blurredBg = PARAMS.makeSprite(game, 0, 0, 'blurredBg');
            this.blurredBg.anchor.set(0.5);
            this.view.add(this.blurredBg)
        }

        this.bg = game.make.graphics();
        this.view.add(this.bg);

        this.bg.beginFill(0x000000, 1);
        this.bg.drawRect(-100, -100, 200, 200);
        this.bg.endFill();

        this.bg.alpha = 0.5;
        this.bg.scale.set(10);
        this.screens = {};

        this.screens['gameStart'] = this.gameStart = new GameStartScreen(game, this);
        this.screens['levelStart'] = this.levelStart = new LevelStartScreen(game, this);
        this.screens['gameSummary'] = this.gameSummary = new GameSummaryScreen(game, this);
        this.screens['pause'] = this.pause = new PauseScreen(game, this);
        this.screens['fakePause'] = this.fakePause = new FakePauseScreen(game, this);
        this.screens['doubleScore'] = this.doubleScore = new DoubleScoreScreen(game, this);
        this.screens['exitGame'] = this.exitGame = new ExitGameScreen(game, this);
        this.screens['help1'] = this.help1 = new HelpScreen1(game, this);
        this.screens['help2'] = this.help2 = new HelpScreen2(game, this);
        this.screens['help3'] = this.help3 = new HelpScreen3(game, this);
        this.screens['help4'] = this.help4 = new HelpScreen4(game, this);
        this.screens['help5'] = this.help5 = new HelpScreen5(game, this);

        this.activeScreen = null;
        this.tweenTime = 250;
        this.showScreen('gameStart')
    }

    showScreen(screenName) {
        _gameGATracker('send', 'pageview', {'page': '/' + screenName + 'Screen'});

        if (screenName === 'help1') {
            this.game.add.tween(this.bg).to({alpha: 0.8}, 250).start()
        }
        if (this.activeScreen) {
            this.makeTransition(screenName);
            return;
        }

        var screen = this.screens[screenName];
        screen.view.alpha = 1;
        screen.view.x = 0;

        this.activeScreen = screen;
        this.view.add(this.activeScreen.view);
        this.activeScreen.onShowStarted();

        var tween = this.game.add.tween(this.view)
            .to({alpha: 1}, this.tweenTime)
            .start();

        this.game.time.events.add(this.tweenTime, function () {
            tween.stop();
            this.view.alpha = 1;

            this.activeScreen.onShowEnded()
        }, this)
    }

    hideScreen() {
        if (!this.activeScreen) {
            this.view.alpha = 0;
            return;
        }

        _gameGATracker('send', 'pageview', {'page': '/GameScene'});

        var screen = this.activeScreen;

        var tween = this.game.add.tween(this.view)
            .to({alpha: 0}, this.tweenTime)
            .start();

        this.game.time.events.add(this.tweenTime, function () {
            tween.stop();
            this.view.alpha = 0;
            this.activeScreen.onHideEnded();
            this.activeScreen.view.x = 100000;
            this.view.removeChild(this.activeScreen.view);
            this.activeScreen = null
        }, this);

        this.activeScreen.onHideStarted()
    }

    makeTransition(screenName) {
        var newScreen = this.screens[screenName];
        var oldScreen = this.activeScreen;

        newScreen.view.x = 0;
        newScreen.view.alpha = 0;
        this.view.add(newScreen.view);

        this.game.tweens.removeFrom(newScreen.view);
        this.game.tweens.removeFrom(oldScreen.view);

        newScreen.onShowStarted();
        oldScreen.onHideStarted();

        var tween = this.game.add.tween(newScreen.view)
            .to({alpha: 1}, this.tweenTime)
            .start();

        var tween2 = this.game.add.tween(oldScreen.view)
            .to({alpha: 0}, this.tweenTime / 2)
            .start();

        this.game.time.events.add(this.tweenTime, function () {
            tween.stop();
            tween2.stop();
            newScreen.view.alpha = 1;
            oldScreen.view.alpha = 0;
            oldScreen.view.x = 1000000;
            newScreen.onShowEnded();
            this.activeScreen = newScreen;
            oldScreen.onHideEnded();
            this.view.removeChild(oldScreen.view)
        }, this)
    }

    showScreenQuickly(screenName) {
        if (this.activeScreen) {
            this.anciveScreen.onHideStarted();
            this.activeScreen.view.alpha = 0;
            this.view.removeChild(this.activeScreen.view);
            this.anciveScreen.onHideEnded();
            this.activeScreen.view.x = 100000
        }

        var screen = this.screens[screenName];

        screen.onShowStarted();

        this.view.alpha = 1;

        this.view.addChild(screen.view);
        screen.view.alpha = 1;

        this.activeScreen = screen;
        this.activeScreen.view.x = 0;

        screen.onShowEnded()
    }

    setOrientation(orientation) {
        this.gameStart.updateTexts();
        this.levelStart.updateTexts();
        this.gameSummary.updateTexts();
        this.pause.updateTexts();
        this.fakePause.updateTexts();
        this.doubleScore.updateTexts();
        this.exitGame.updateTexts();
        this.help1.updateTexts();
        this.help2.updateTexts();
        this.help3.updateTexts();
        this.help4.updateTexts();
        this.help5.updateTexts();

        if (orientation === 'portrait') {
            this.help1.setOrientation('p');
            this.help2.setOrientation('p');
            this.help3.setOrientation('p');
            this.help4.setOrientation('p');
            this.help5.setOrientation('p')
        } else {
            this.help1.setOrientation('l');
            this.help2.setOrientation('l');
            this.help3.setOrientation('l');
            this.help4.setOrientation('l');
            this.help5.setOrientation('l')
        }
    }
}
